<template>
  <VcCommand />
</template>
